import { Injectable } from '@angular/core'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import {
  CheckoutPaymentTypeConnector,
  CheckoutPaymentTypeService
} from '@spartacus/checkout/b2b/core'
import { CheckoutPaymentTypeSetEvent } from '@spartacus/checkout/b2b/root'
import { CheckoutQueryFacade, CheckoutQueryResetEvent } from '@spartacus/checkout/base/root'
import {
  Command,
  CommandService,
  CommandStrategy,
  EventService,
  QueryService,
  UserIdService
} from '@spartacus/core'
import { combineLatest, Observable } from 'rxjs'
import { filter, map, switchMap, take, tap } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class EbPaymentTypeService extends CheckoutPaymentTypeService {
  constructor(
    activeCartFacade: ActiveCartFacade,
    userIdService: UserIdService,
    queryService: QueryService,
    commandService: CommandService,
    paymentTypeConnector: CheckoutPaymentTypeConnector,
    eventService: EventService,
    checkoutQueryFacade: CheckoutQueryFacade,
    protected multiCartFacade: MultiCartFacade
  ) {
    super(
      activeCartFacade,
      userIdService,
      queryService,
      commandService,
      paymentTypeConnector,
      eventService,
      checkoutQueryFacade
    )
  }

  protected override setPaymentTypeCommand: Command<{
    paymentTypeCode: string
    purchaseOrderNumber?: string
  }> = this.commandService.create(
    payload => {
      return this.checkoutPreconditions().pipe(
        switchMap(([userId, cartId]) =>
          this.paymentTypeConnector
            .setPaymentType(userId, cartId, payload.paymentTypeCode, payload.purchaseOrderNumber)
            .pipe(
              tap(() =>
                this.multiCartFacade.loadCart({
                  cartId,
                  userId
                })
              ),
              tap(() => this.eventService.dispatch({}, CheckoutQueryResetEvent)),
              tap(() =>
                this.eventService.dispatch(
                  {
                    userId,
                    cartId,
                    paymentTypeCode: payload.paymentTypeCode,
                    purchaseOrderNumber: payload.purchaseOrderNumber
                  },
                  CheckoutPaymentTypeSetEvent
                )
              )
            )
        )
      )
    },
    {
      strategy: CommandStrategy.CancelPrevious
    }
  )

  protected override checkoutPreconditions(): Observable<[string, string]> {
    return combineLatest([
      this.activeCartFacade.getActiveCartId(),
      this.userIdService.takeUserId(true)
    ]).pipe(
      filter(([cartId, userId]) => !!(cartId && userId)),
      take(1),
      map(([cartId, userId]) => {
        return [userId, cartId]
      })
    )
  }
}
